import React from "react";
import CustomModal from "../../common/CustomModal";
import AdDeliverCreate from "../AdDeliverCreate";

const NewDeliveryModal = ({ open, onClose, resubmitInitial = null, initialRequestId = null }) => (
  <CustomModal open={open} title={resubmitInitial ? "Resubmit delivery" : "New delivery"} onClose={onClose} isButtonsRequired={false}>
    <AdDeliverCreate
      // Keyed on the request so a second Deliver remounts rather than merges.
      key={
        resubmitInitial
          ? `resubmit-${resubmitInitial.type}-${resubmitInitial.delivery_id ?? ""}-${resubmitInitial.ad_request_id ?? ""}-${resubmitInitial.ad_id ?? ""}`
          : `new-${initialRequestId ?? ""}`
      }
      onSuccess={onClose}
      resubmitInitial={resubmitInitial}
      initialRequestId={initialRequestId}
    />
  </CustomModal>
);

export default NewDeliveryModal;
